import React from 'react';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import MerchantExperienceContent
  from 'core/modules/Instore2/components/MePage/_can/MerchantExperienceContent';

function MerchantExperience() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <MerchantExperienceContent />
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

export default MerchantExperience;
